/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ActivityInputs */

const th_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความเคลื่อนไหว`)
};

const en_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

const ja_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティビティ`)
};

const zh_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动态`)
};

const es_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad`)
};

const pt_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

const id_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitas`)
};

const fr_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité`)
};

const tl_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktibidad`)
};

const vi_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động`)
};

const ko_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활동`)
};

const de_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivität`)
};

const ru_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активность`)
};

const tr_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik`)
};

const it_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività`)
};

const pl_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywność`)
};

const uk_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активність`)
};

const hi_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गतिविधि`)
};

const ar_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشاط`)
};

const ms_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviti`)
};

const bn_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কার্যকলাপ`)
};

const zh_tw2_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動態`)
};

const zh_hk2_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動態`)
};

const ur_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سرگرمی`)
};

const fa_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فعالیت`)
};

const sw_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shughuli`)
};

const nl_activity = /** @type {(inputs: ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activiteit`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {ActivityInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const activity = /** @type {((inputs?: ActivityInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ActivityInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_activity(inputs)
	if (locale === "ja") return ja_activity(inputs)
	if (locale === "zh") return zh_activity(inputs)
	if (locale === "es") return es_activity(inputs)
	if (locale === "pt") return pt_activity(inputs)
	if (locale === "id") return id_activity(inputs)
	if (locale === "fr") return fr_activity(inputs)
	if (locale === "tl") return tl_activity(inputs)
	if (locale === "vi") return vi_activity(inputs)
	if (locale === "ko") return ko_activity(inputs)
	if (locale === "de") return de_activity(inputs)
	if (locale === "ru") return ru_activity(inputs)
	if (locale === "tr") return tr_activity(inputs)
	if (locale === "it") return it_activity(inputs)
	if (locale === "pl") return pl_activity(inputs)
	if (locale === "uk") return uk_activity(inputs)
	if (locale === "hi") return hi_activity(inputs)
	if (locale === "ar") return ar_activity(inputs)
	if (locale === "ms") return ms_activity(inputs)
	if (locale === "bn") return bn_activity(inputs)
	if (locale === "zh-TW") return zh_tw2_activity(inputs)
	if (locale === "zh-HK") return zh_hk2_activity(inputs)
	if (locale === "ur") return ur_activity(inputs)
	if (locale === "fa") return fa_activity(inputs)
	if (locale === "sw") return sw_activity(inputs)
	if (locale === "nl") return nl_activity(inputs)
	return en_activity(inputs)
});